import React from 'react';
import useEmployee from './useEmployee';
import Employee from './Components/Employee';

const EmployeeIndex: React.FC = () => {
  const employeeProps = useEmployee();

  return (
  <Employee/>
);
};
export default EmployeeIndex;
